module.exports = __webpack_public_path__ + "img/408.83a8dc6b.jpg";